import { ShieldAlert } from "lucide-react";
import type { MouseEvent } from "react";
import { cn } from "@/lib/utils";

export function RiskBadge({
  count,
  onClick,
  className,
  title,
}: {
  count: number;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  title?: string;
}) {
  if (count === 0) return null;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className={cn(
        "absolute -top-2 -left-2 z-10 rounded-full px-1.5 py-0.5 text-[10px] font-medium flex items-center gap-1 border bg-danger-soft text-danger-ink border-danger/30 hover:bg-danger/15 transition-colors",
        className,
      )}
      title={title ?? `${count} risk${count === 1 ? "" : "s"} — click to view`}
    >
      <ShieldAlert className="h-2.5 w-2.5" />
      <span>{count}</span>
    </button>
  );
}
